import {
  cloneDashboardForUser,
  updateDashboardWidget,
} from '@akin-home/dashboards';
import {
  createDashboardMutation,
  dashboardModelToCreateInput,
  dashboardModelToUpdateInput,
  updateDashboardMutation,
} from '@akin-home/dashboards/frontend';
import { dashboard_query_keys } from '@akin-home/dashboards/react';
import { asyncPipe } from '@akin-home/utils/fp';
import { AppStateSlice } from '../../stores/app_state';
import { DashboardState } from './types';

export const createDashboardStateStore: AppStateSlice<DashboardState> = (
  set,
  get
) => ({
  dashboard_layout: {
    height: 0,
    width: 0,

    orientation: 'landscape',

    cell_layout: {
      height: 0,
      width: 0,
    },
  },

  setDashboard(current_dashboard, using_default_dashboard) {
    set({
      current_dashboard,
      using_default_dashboard,
    });
  },

  setDashboardLayout({ width, height }) {
    set({
      dashboard_layout: {
        width,
        height,
        orientation: width >= height ? 'landscape' : 'portrait',
        cell_layout: {
          width: width / 12,
          height: height / 12,
        },
      },
    });
  },

  async updateDashboardWidget(widget) {
    const {
      current_dashboard,
      using_default_dashboard,
      current_user: user,
    } = get();

    if (!current_dashboard || !user) return;

    if (using_default_dashboard) {
      /** Clone the default dashboard */
      await asyncPipe(
        updateDashboardWidget({ widget }),
        cloneDashboardForUser({ user }),
        dashboardModelToCreateInput,
        toInput,
        createDashboardMutation
      )(current_dashboard);

      get().query_client.invalidateQueries(dashboard_query_keys.lists());
    } else {
      const { data } = await asyncPipe(
        updateDashboardWidget({ widget }),
        dashboardModelToUpdateInput,
        toInput,
        updateDashboardMutation
      )(current_dashboard);

      const { query_client } = get();

      query_client.invalidateQueries(dashboard_query_keys.lists());

      query_client.setQueryData(
        dashboard_query_keys.detail(data.updateDashboard?.id),
        () => data.updateDashboard
      );
    }
  },
});

const toAttribute = <X extends string>(attribute: X) =>
  function <T>(object: T): Record<X, T> {
    return { [attribute]: object } as Record<X, T>;
  };

const toInput = toAttribute('input');
